import React from "react";
import Book from "../Books/Book";
import OtherBook from "../Books/OtherBook";
import { NavLink } from "react-router-dom";
import SkunkWhoCouldntSmellFrontCover from "../../../images/SkunkWhoCouldntSmellFrontCover.jpg";
import SkunkWhoCouldntSmellBackCover from "../../../images/SkunkWhoCouldntSmellBackCover.jpg";
import SkunkSwapFrontCover from "../../../images/SkunkSwapFrontCover.jpg";
import SkunkSwapBackCover from "../../../images/SkunkSwapBackCover.jpg";
import OllieTheOwlFrontCover from "../../../images/OllieTheOwlFrontCover.jpg";
import OllieTheOwlBackCover from "../../../images/OllieTheOwlBackCover.jpg";

function Books() {
  return (
    <div>
      <div>
        <div className="container">
          {/* <div className="row pt-3">
            <div className="sm-col-1 lg-col-4"></div>
            <div className="sm-col-10 lg-col-4 d-flex justify-content-center">
              <NavLink
                className="btn text-white"
                to="/BeTheFirstToKnow"
                style={{
                  fontFamily: "comic sans ms",
                  backgroundColor: "#70bf54",
                  borderColor: "#00854a",
                }}
              >
                Be the first to know!
              </NavLink>
            </div>
            <div className="sm-col-1 lg-col-4"></div>
          </div> */}

          <div className="row">
            <div className="d-flex justify-content-center">
              <Book
                title="The Skunk Who Couldn't Smell"
                frontCover={SkunkWhoCouldntSmellFrontCover}
                backcover={SkunkWhoCouldntSmellBackCover}
                paperbackLink="https://www.amazon.com/Skunk-Who-Couldnt-Smell/dp/B0CJHB9HR7/ref=sr_1_1?crid=YNLGXKMSN8TX&keywords=the+skunk+who+couldn%27t+smell&qid=1695572122&sprefix=the+skunk+who+%2Caps%2C267&sr=8-1"
                hardcoverLink="#"
              />
            </div>
          </div>

          <div className="row">
            <div className="d-flex justify-content-center">
              <Book
                title="The Skunk Swap"
                frontCover={SkunkSwapFrontCover}
                backcover={SkunkSwapBackCover}
                paperbackLink="https://www.amazon.com/Skunk-Swap-Sarah-McCormick/dp/B0DPDMPPRF/ref=sr_1_1?crid=22AEXNHM11R2B&dib=eyJ2IjoiMSJ9.HPtJDOdEjOU9lmW8PCEZd8Ler_J9jm5UUDj0DtrPblZctxl5Xq99gtcyK_yKwpiMB1gL-V3lh8L0XmIP-VydrFO9k1RKhXHhrXuuRA6Ea-cbi2CsAPxoFqJIo3_SBAdERFyqXBj-ONknV1gDmIA2BCH33T7jWy8q-nttMsKOShBPB9m2jkjojfPMJH3B880CGhJBkETnIVfbFW3Wsl1w2O54U8p5SnA7xaYlQqv8ZjeRYnRDqLpeFOcX8FBm4kIpuDCJpEZ7nFKQLPGYuNYPPSf9qBzPr_B6pvCt9o9wUDI.c2lT63F3dJAs8HoTCvuKyrOND0DxWzGY_wbs2BJcypY&dib_tag=se&keywords=skunk+swap&qid=1746841791&sprefix=skunk+swap%2Caps%2C127&sr=8-1"
                hardcoverLink="#"
              />
            </div>
          </div>

          <div className="row">
            <div className="d-flex justify-content-center">
              <OtherBook
                title="Ollie The Owl"
                frontCover={OllieTheOwlFrontCover}
                backcover={OllieTheOwlBackCover}
                paperbackLink="test.com"
                hardcoverLink="#"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Books;
